import moment from 'moment';
import _ from 'lodash';
import formatCurrency from 'format-currency';

class InvoiceReportController {
  constructor($rootScope, $uibModal, $state, $http) {
    "ngInject";
    this.state = $state;
    this.$http = $http;
    this.queryResult;
    this.$rootScope = $rootScope;
    this.customerFilter = 'all';
    this.contractFilter = 'all';
    this.taskFilter = 'all';
    this.formatCurrency = formatCurrency;
    this.contractOptions = [];
    this.projectOptions = [];

    let self = this;
    this.$http.get(this.baseUrl+name)

    this.$http.get($rootScope.apiHost+"/api/reports/laborRevenueByTimePeriod", {withCredentials: true}).then(function (success) {
      self.report = success.data;
      self.queryParams = self.report.filterParameters;
      self.queryParams.dateRange = {
        name: "dateRange",
        value: "thisYear"
      };

      self.search();
    });

    this.$http.get($rootScope.apiHost+"/api/admin/customers", {withCredentials: true}).then(function (success) {
      self.customers = success.data;
    });

    this.opened = {};
    this.open = function($event, elementOpened) {
      $event.preventDefault();
      $event.stopPropagation();
      self.opened[elementOpened] = !self.opened[elementOpened];
    };

    this.datePickerFormat = 'MMM dd, yyyy';
    this.datePickerOptions = {
      formatYear: 'yyyy',
      formatMonth: 'MMM',
      formatDay: 'dd',
      // maxDate: new Date(2020, 5, 22),
      minDate: new Date(1999,1,1),
      startingDay: 1
    };
  }



  search() {
    console.log('search called');
    let self = this;
    self.queryResult = [];

    if(this.queryParams.dateRange.value === 'custom') {

      if(this.queryParams.startDate.value == 'default') {
        this.queryParams.startDate.value = moment().startOf("month").toDate();
      }

      if(this.queryParams.endDate.value == 'default') {
        this.queryParams.endDate.value = moment().endOf("month").toDate();
      }

      this.queryParams.startDate.value.setHours(0);
      this.queryParams.startDate.value.setMinutes(0);
      this.queryParams.startDate.value.setSeconds(0);
      this.queryParams.startDate.value.setMilliseconds(0);

      this.queryParams.endDate.value.setHours(0);
      this.queryParams.endDate.value.setMinutes(0);
      this.queryParams.endDate.value.setSeconds(0);
      this.queryParams.endDate.value.setMilliseconds(0);
    }





    if(this.taskFilter && this.taskFilter !== 'all') {
      this.queryParams.taskOrder.value = this.taskFilter.id;
    } else {
      this.queryParams.taskOrder.value = 'default';
    }


    this.$http.post(this.$rootScope.apiHost+"/api/reports/laborRevenueByTimePeriod", this.queryParams, {withCredentials: true}).then(function (success) {
      self.queryResult = success.data;
    });
  }

  selectCustomer() {
    let self = this;

    this.queryParams.contract.value = 'default';
    this.queryParams.taskOrder.value = 'default';


    self.contractFilter = 'all';
    self.taskFilter = 'all';
    self.contractOptions = [];
    self.projectOptions = [];

    if(this.customerFilter && this.customerFilter !== 'all') {
      this.queryParams.customer.value = this.customerFilter.id;
      this.$http.get(self.$rootScope.apiHost+"/api/admin/contracts/bycustomer?customer="+this.customerFilter.id, {withCredentials: true}).then(function (success) {
        self.contractOptions = success.data;
      });
    }

    self.search();
  }

  selectContract() {
    let self = this;

    this.queryParams.contract.value = 'default';
    this.queryParams.taskOrder.value = 'default';

    self.taskFilter = 'all';
    self.projectOptions = [];

    if(this.contractFilter && this.contractFilter !== 'all') {
      this.queryParams.contract.value = this.contractFilter.id;
      this.$http.get(self.$rootScope.apiHost+"/api/admin/projects/bycontract?contract="+this.contractFilter.id, {withCredentials: true}).then(function (success) {
        self.projectOptions = success.data;
      });
    }

    self.search();
  }



  toCurrency(value) {
    return formatCurrency(value);
  }

  // getTotalDollars() {
  //   let total = 0;
  //   if(this.queryResult) {
  //     this.queryResult.forEach(function (key, value) {
  //       total += key["Total"];
  //     });
  //   }
  //
  //   let opts = { format: '%s%v', symbol: '$' }
  //   return formatCurrency(total, opts);
  // }
  //
  // getTotalHours() {
  //   let total = 0;
  //   if(this.queryResult) {
  //     this.queryResult.forEach(function (key, value) {
  //       total += key["Hours"];
  //     });
  //   }
  //
  //   return formatCurrency(total.toFixed(2));
  // }


  getTotalHours() {
    let totalHours = 0;
    if(this.queryResult) {
      this.queryResult.forEach(function (result) {
        totalHours = totalHours + result.hours;
      });
    }

    return totalHours;
  }

  getTotalDollars() {
    let totalHours = 0;
    if(this.queryResult) {
      this.queryResult.forEach(function (result) {
        totalHours = totalHours + result.total;
      });
    }

    return totalHours;
  }


  getContractsForCustomer(customerId) {
    let currentCustomer = _.find(this.customers, {'id': customerId});
    if(currentCustomer) {
      return currentCustomer.contracts;
    } else {
      return [];
    }
  }

  getTaskOrdersForContract(customerId, contractId) {
    let currentCustomer = _.find(this.customers, {'id': customerId});

    if(currentCustomer) {
      let currentContract = _.find(currentCustomer.contracts, {'id': contractId});

      if (currentContract) {
        return currentContract.tasks;
      } else {
        return [];
      }
    } else {
      return [];
    }
  }


}

export default InvoiceReportController;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/invoice-report/invoice-report.controller.js